import { api } from '../client';

export type DeploymentStatus = 'OUT' | 'OVERDUE' | 'UNSCHEDULED' | 'LOST_IN_HOLE' | 'RETURNED';

export interface DeployedAsset {
  /** The assignment, not the asset — an asset can go out more than once. */
  id: string;
  equipmentId: string;
  assetNumber: string;
  name: string;
  category: string;
  jobId: string;
  jobNumber: string;
  jobName: string;
  jobStatus: string;
  wellName: string | null;
  assignedAt: string;
  expectedReturnAt: string | null;
  lostInHoleNote: string | null;
  status: DeploymentStatus;
  daysOut: number;
  /** Null when it is not late, or when nobody said when it was due. */
  daysOverdue: number | null;
  statement: string;
}

export interface DeployedSummary {
  out: number;
  overdue: number;
  unscheduled: number;
  lostInHole: number;
  worstOverdueDays: number;
}

export const deploymentApi = {
  async getDeployed(includeReturned = false) {
    const response = await api.get<DeployedAsset[]>('/equipment/deployed', {
      params: includeReturned ? { includeReturned: 'true' } : undefined,
    });
    return response.data;
  },

  async getSummary() {
    const response = await api.get<DeployedSummary>('/equipment/deployed/summary');
    return response.data;
  },

  async recordReturn(assignmentId: string, returnedAt?: string) {
    const response = await api.patch(`/equipment/deployed/${assignmentId}/return`, { returnedAt });
    return response.data;
  },

  async recordLostInHole(assignmentId: string, note?: string) {
    const response = await api.patch(`/equipment/deployed/${assignmentId}/lost-in-hole`, { note });
    return response.data;
  },

  async setExpectedReturn(assignmentId: string, expectedReturnAt: string | null) {
    const response = await api.patch(`/equipment/deployed/${assignmentId}/expected-return`, {
      expectedReturnAt,
    });
    return response.data;
  },
};
